/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function BoldIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M8 7.5C8 6.688 8.625 6 9.5 6h11.75C25.5 6 29 9.5 29 13.75a7.74 7.74 0 0 1-2.375 5.563C29.188 20.563 31 23.25 31 26.25c0 4.313-3.5 7.75-7.75 7.75H9.5c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5H11V9H9.5C8.625 9 8 8.375 8 7.5m13.25 11A4.75 4.75 0 0 0 26 13.75 4.75 4.75 0 0 0 21.25 9H14v9.5zm-7.25 3V31h9.25A4.75 4.75 0 0 0 28 26.25a4.75 4.75 0 0 0-4.75-4.75H14"/>}
        </IconWrapper>);
}
